import { __spreadArrays } from "tslib";
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
/**
 * How to debug redux actions locally:
 1. npm run start-redux-dev-server
 2. enable composeWithDevTools line below
 3. http://localhost:8000/
*/
var setupStore = function (rootReducer, initialState, middleware) {
    if (middleware === void 0) { middleware = []; }
    var allMiddleware = __spreadArrays([promiseMiddleware, thunk], middleware);
    var composeEnhancers = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            name: 'chat-sdk',
        })
        : compose;
    // const composeEnhancers = require('remote-redux-devtools').composeWithDevTools({hostname: 'localhost', realtime: true, port: 8000});
    var enhancer = composeEnhancers(applyMiddleware.apply(void 0, allMiddleware));
    var store = createStore(rootReducer, initialState, enhancer);
    return store;
};
export default setupStore;
